import React, {ReactNode} from "react";

export function renderText(text: string | null | undefined): ReactNode {
	if (!text)
		return undefined;
	return text.split(/\r?\n\r?\n/)
		.map(renderParagraph);
}

export function renderParagraph(text: string | null | undefined, index?: number): ReactNode {
	if (!text)
		return undefined;
	return <p key={index}>
		{renderLines(text)}
	</p>;
}

export function renderLines(text: string | null | undefined): ReactNode {
	if (!text)
		return undefined;
	return text.split(/\r?\n/)
		.map(renderLine);
}

export function renderLine(text: string | null | undefined, index?: number): ReactNode {
	if (!text)
		return undefined;
	return <span key={index}>{text}<br/></span>;
}
